<template>
  <div>
    <div
      class="rounded-lg justify-between items-center rounded-lg mb-10"
      style="
        background-image: url(https://ip-connect-zone.b-cdn.net/page-banners/global-banner.png);
        box-shadow: rgb(0 0 0 / 10%) 0px 4px 25px 0px;
      "
    >
      <div class="flex justify-between items-center rounded-lg p-4" style="border: 1px solid #222f44">
        <div class="flex items-center">
          <img
            alt="simulations"
            draggable="false"
            src="https://connect-cdn.intellectualpoint.com/assets/images/apps/FlashCardsIcon.png"
            class="rounded hidden sm:block mr-5"
            style="width: 75px"
          />
          <div>
            <h1 class="font-bold">FlashCards Selector</h1>
            <h5 class="font-light">{{ totalSets }} Total Sets</h5>
          </div>
        </div>
      </div>
    </div>

    <div class="vx-row" v-if="courseData && selectorData">
      <div class="vx-col w-full">
        <div class="mb-16 set-container" v-for="(domain, dIndex) in selectorData" :key="dIndex">
          <div class="set-domain-container">
            <h2 class="font-medium p-3 px-8 rounded-lg set-domain-name" style="background-color: #040916; border: 1px solid #222f44">
              {{ domain.name }}
            </h2>
            <h2 class="font-light p-3 px-8 rounded-lg set-domain-sets" style="background-color: #040916; border: 1px solid #222f44">
              {{ domain.sets.length }} Sets
            </h2>
          </div>
          <div class="grid grid-cols-sets gap-5">
            <div v-for="(set, index) in domain.sets" :key="index" class="flex items-center justify-center">
              <set-card
                :id="set.id"
                :name="set.name"
                :thumbnail="set.thumbnail"
                :percent="set.percent"
                :termsCompleted="set.termsCompleted"
                :termsCount="set.termsCount"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="simple-spinner">
      <span></span>
    </div>
  </div>
</template>

<script>
import LottieAnimation from '../../../../components/lottie/LottieAnimation';
import SetCard from './components/FlashCardSetCard';

export default {
  data() {
    return {
      courseData: null,
      selectorData: null,
      totalSets: 0,

      showHiddenSets: false,
    };
  },
  computed: {
    setColorProgress() {
      const theme = this.$store.state.theme;
      if (theme === 'light') return 'rgba(0,0,0,0.2)';
      if (theme === 'dusk') return 'rgba(0,0,0,0.5)';
      if (theme === 'dark') return 'rgba(0,0,0,0.2)';
    },
    activeCourseInfo() {
      return this.$store.state.AppActiveCourse;
    },
  },
  components: {
    SetCard,
    LottieAnimation,
  },
  methods: {
    fetchCourseDetails(id) {
      if (this.activeCourseInfo.selected === false) {
        this.$vs.notify({
          title: 'No Course Selected',
          text: 'Please select a courses before practicing',
          color: 'danger',
          position: 'top-right',
        });
        return this.$router.push('/courses');
      }

      this.$http
        .get(`courses/${id}`)
        .then((response) => {
          if (response.status === 200) {
            this.courseData = response.data.data;
            this.fetchSelectorData(id);
          }
        })
        .catch(() => {});
    },
    fetchSelectorData() {
      this.$http
        .get('app/flashcards/selector')
        .then((response) => {
          if (response.status === 200) {
            this.selectorData = response.data.data;
            let length = 0;
            this.selectorData.forEach((domain) => {
              length = length + domain.sets.length;
            });
            this.totalSets = length;
          }
        })
        .catch(() => {});
    },
    lottiePlay(ref) {
      this.$refs[ref][0].play();
    },
    lottieStop(ref) {
      this.$refs[ref][0].stop();
    },
  },
  created() {
    this.fetchCourseDetails(this.activeCourseInfo.id);

    setTimeout(() => {
      this.currentStep = 1;
    }, 1500);
  },
  beforeDestroy() {
    this.courseData = null;
    this.selectorData = null;
  },
};
</script>

<style scoped>
.grid-cols-sets {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.set-container {
  padding: 1.5rem;
  background-color: #02050d;
  border-radius: 0.6rem;
}

.set-domain-container {
  display: flex;
  align-items: center;
  column-gap: 1rem;
  margin-bottom: 1rem;
}

@media (max-width: 1800px) {
  .grid-cols-sets {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 1350px) {
  .grid-cols-sets {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}

@media (min-width: 1000px) and (max-width: 1150px) {
  .grid-cols-sets {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 750px) {
  .set-domain-name {
    font-size: 18px;
    padding: 0rem !important;
    border: none !important;
  }

  .set-domain-sets {
    font-size: 18px;
    border: none !important;
    padding: 0rem !important;
  }

  .set-container {
    padding: 0rem;
    background-color: transparent;
    border-radius: 0.6rem;
  }

  .set-domain-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    column-gap: 1rem;
    border: 1px solid #222f44;
    background-color: #02050d;
    padding: 0.8rem 1rem 0.8rem 1rem;
    border-radius: 0.6rem;
  }

  .set-domain-sets {
    margin-top: 0rem;
  }
}
</style>
